import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { IItemCardList } from 'models/itemcard';
import { ItemCardList } from '../ItemList/ItemCardList';
import { ErrorSummary } from '../ErrorPages/ErrorSummary';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { INotification } from 'models/notifications/notification';
import { IPage } from 'models/common';
import { getUserCard } from 'modules/user/usercard';
import { getProductCard } from 'modules/product/productcard';
import { getShopCard } from 'modules/shop/shopcard';
import { IUserCardAction } from 'models/user/usercard';
import { IProductCardDataAction } from 'models/product/productcard';
import { IShopCardAction, IShopCard } from 'models/shop/shopcard';
import renderIcon from 'helpers/renderIcon';
const { connect } = require('react-redux');

interface IProps {
	message: any;
	error: boolean;
	items?: INotification[];
	itemsPage?: IPage;
	selectedTab: string;
	shop?: IShopCard;

	/* func props */
	t?: (x: string) => string;
	changeTabAndGetRequiredData: (selectedTab: string) => void;
	loadMoreNotifications?: () => void;
	onNotificationClick?: (id: string) => void;
	getUserCard?: (id: string) => IUserCardAction;
	getProductCard?: (id: string) => IProductCardDataAction;
	getShopCard?: (id: string) => IShopCardAction;
}

@connect(
	() => ({}),
	(dispatch) => ({
		getUserCard: (id: string) => dispatch(getUserCard(id)),
		getProductCard: (id: string) => dispatch(getProductCard(id)),
		getShopCard: (id: string) => dispatch(getShopCard(id)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class Notifications extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.handleOnNotificationClick = this.handleOnNotificationClick.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}

	public componentDidMount() {
		this.props.changeTabAndGetRequiredData(c.NOTIFICATIONS_TAB_USER);
	}

	private handleOnNotificationClick(id: string) {
		if (this.props.onNotificationClick) {
			this.props.onNotificationClick(id);
		}
	}

	private goToCard(id: string, type: string) {
		switch (type) {
			case c.NODE_TYPE_USER:
				this.props.getUserCard(id);
				break;

			case c.NODE_TYPE_PRODUCT:
				this.props.getProductCard(id);
				break;

			case c.NODE_TYPE_SHOP:
				this.props.getShopCard(id);
				break;

			default:
				break;
		}
	}

	public render() {
		const errorSummaryProps = {
			error: this.props.error,
			message: this.props.message,
		};

		const { items, itemsPage, selectedTab, shop } = this.props;
		const { t } = this.props;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: () => {
				this.props.loadMoreNotifications();
			},
			hasMore: itemsPage.totalItems > items.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IItemCardList = {
			items,
			itemType: c.NODE_TYPE_NOTIFICATION_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			noResults: (
				<div className="errorMessage">
					{renderIcon('great')}
					{t('Notifications_Message_NoNotifications')}
				</div>
			),
			goToCard: this.goToCard,
			customFunction: this.handleOnNotificationClick,
			customProps: shop,
		};

		const noItems: JSX.Element = (
			<div className="errorMessage">
				{renderIcon('great')}
				{t('Notifications_Message_NoNotifications')}
			</div>
		);

		const itemsContent = listProps.items?.length ? <ItemCardList {...listProps} /> : noItems;

		return (
			<div className="notificationsContainer">
				<div className="profileError">
					<ErrorSummary {...errorSummaryProps} />
				</div>
				{shop ? (
					<Tabs
						name="notificationsTabs"
						tabComponent="div"
						renderActiveTabContentOnly={true}
						selectedTab={selectedTab}
						handleSelect={(selectedTab) => {
							this.props.changeTabAndGetRequiredData(selectedTab);
						}}
					>
						<div className="tabsText">
							<div className="tabsText">
								<TabLink className="tab-link" key="notificationsuserlink" to={c.NOTIFICATIONS_TAB_USER}>
									{t('Notifications_Label_Profile')}
								</TabLink>
								{shop ? (
									<TabLink className="tab-link" key="notificationsshoplink" to={c.NOTIFICATIONS_TAB_SHOP}>
										{t('Notifications_Label_Shop')}
									</TabLink>
								) : null}
							</div>
						</div>
						<div className="notificationsBody">
							<TabContent key="notificationsusercontent" for={c.NOTIFICATIONS_TAB_USER}>
								{itemsContent}
							</TabContent>
							{shop ? (
								<TabContent key="notificationsshopcontent" for={c.NOTIFICATIONS_TAB_SHOP}>
									{itemsContent}
								</TabContent>
							) : null}
						</div>
					</Tabs>
				) : (
					<div className="notificationsBody">{itemsContent}</div>
				)}
			</div>
		);
	}
}

export { Notifications };
